// extracted by mini-css-extract-plugin
export default {"container":"Plug-module__container--HLD3Q","image":"Plug-module__image--jykME","text":"Plug-module__text--bn5v7","siteButton":"Plug-module__siteButton--_Tgjx"};